<template>
  <div class="container">
    <div class="user-profile-page text-center">
      <h2>Perfil del usuario</h2>
    </div>

    <div v-if="user">
      <p>{{ user.id }}</p>
      <p>{{ user.name }}</p>
      <p>{{ user.email }}</p>
      <p>{{ user.roleName }}</p>
    </div>

  </div>
</template>

<script>
export default {
  name: "Profile",
  data() {
    return {};
  },
  methods: {},
  computed: {
    user() {
      return this.$store.state.user.userLogged;
    }
  },
}
</script>